import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { ContentItem } from "@/mocks/content";

export default function NewsTicker({ items }: { items: ContentItem[] }) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused || items.length <= 1) return;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % items.length);
    }, 3500);
    return () => clearInterval(timer);
  }, [paused, items.length]);

  if (items.length === 0) {
    return <p className="text-sm text-foreground-500">暂无资讯快报</p>;
  }

  const current = items[index];

  return (
    <div>
      <div className="flex items-center gap-2 border-b border-background-200/80 pb-3">
        <span className="flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 font-label text-xs font-semibold text-background-50">
          <i className="ri-flashlight-fill" />
          资讯快报
        </span>
        <span className="text-xs text-foreground-500">实时更新</span>
      </div>

      <ul
        className="mt-3 space-y-1"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        {items.map((item, i) => {
          const isActive = i === index;
          return (
            <li key={item.id}>
              <Link
                to={`/detail/${item.id}`}
                onMouseEnter={() => setIndex(i)}
                className={`block rounded-md px-2 py-2 transition-colors ${
                  isActive ? "bg-accent-50" : "hover:bg-background-100"
                }`}
              >
                <div className="flex items-start gap-2">
                  <span
                    className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded text-[10px] font-bold ${
                      isActive ? "bg-accent-500 text-background-50" : "bg-secondary-200 text-secondary-800"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <div className="min-w-0">
                    <p
                      className={`line-clamp-1 text-sm font-medium ${
                        isActive ? "text-accent-700" : "text-foreground-800"
                      }`}
                    >
                      {item.title}
                    </p>
                    {isActive && (
                      <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                        {item.summary}
                      </p>
                    )}
                  </div>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}